import VENUE_ORDER_PICK_UP_TYPES from './venueOrderPickUpTypes'

export default {
  [VENUE_ORDER_PICK_UP_TYPES.IN_STORE]: 'In Store',
  [VENUE_ORDER_PICK_UP_TYPES.CURB_SIDE]: 'Curb Side',
}



// WEBPACK FOOTER //
// ./src/constants/venueOrderPickUpTypeNames.js